/**
 * Does switching patient mode have to RESET the prescription?
 *
 * Yes exactly when the patient panel SEEDED the prescription, and never merely
 * because a patient record is selected. The two mistakes available here are
 * opposite and both reach a manufactured product, and each has been shipped
 * once and caught in review:
 *
 *   * TOO WIDE (`|| value.patientId`) blanks a prescription the operator typed
 *     by hand - a record-backed pick does not by itself seed one.
 *   * TOO NARROW (`reorderFromOrder` alone) leaves patient X's copied
 *     prescription attached to patient Y. Every prescription section is
 *     collapsed by default, so that carryover is invisible until the lab sheet.
 *
 * This lives in its own module, rather than in PatientPicker, for the same
 * reason prescriptionFormDefaults and prescriptionReuse do: PatientPicker
 * imports `@/lib/supabase` eagerly, so importing it from a unit test blows up
 * on a missing supabaseUrl. Typed structurally so it needs no import from
 * PatientPicker at all.
 */
export function shouldResetPrescriptionOnModeSwitch(value: {
  reorderFromOrder?: unknown;
  prescriptionSeededFrom?: string | undefined;
}): boolean {
  return !!value.reorderFromOrder || !!value.prescriptionSeededFrom;
}
